import moment from "moment";
export const today = () => {
  const today = new Date();
  const searchFormat = moment(today)
    .startOf("day")
    .format("YYYY-MM-DD h:mm:ss a");
  return searchFormat;
};

export const todayEnd = () => {
  const today = new Date();
  const searchFormat = moment(today)
    .endOf("day")
    .format("YYYY-MM-DD h:mm:ss a");
  return searchFormat;
};

export const previousweek = () => {
  var today = new Date();
  var previousweek = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() - 7
  );

  return previousweek.toISOString();
};

export const thismonth = () => {
  let date = new Date();
  const thisMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  const searchFormat = moment(thisMonth).format("YYYY-MM-DD h:mm:ss");
  return searchFormat;
};

export const firstDayPreviousMonth = () => {
  const date = new Date();
  const firstDayLastMonth = new Date(
    date.getFullYear(),
    date.getMonth() - 1,
    1
  );
  const searchFormat = moment(firstDayLastMonth).format("YYYY-MM-DD h:mm:ss");
  return searchFormat;
};

export const lastDayPreviousMonth = () => {
  const date = new Date();
  const lastDayLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
  const searchFormat = moment(lastDayLastMonth).format("YYYY-MM-DD h:mm:ss");
  return searchFormat;
};

export const previousSixMonth = () => {
  const date = new Date();
  const lastSix = new Date(date.getFullYear(), date.getMonth() - 6);
  const searchFormat = moment(lastSix).format("YYYY-MM-DD h:mm:ss");
  return searchFormat;
};

export const dateFormat = (date) => {
  const formattedDate = moment(new Date(date)).format("DD-MM-YYYY")
  return formattedDate;
};

export const capitalizeFirstLetter=(str)=> {
  return str[0].toUpperCase() + str.slice(1);
}